module.exports = __webpack_public_path__ + "img/character_details.1ff12af1.png";